import { Component, OnInit } from "@angular/core";
import { LanguageService } from "@core/services/language.service";
import { TranslateService } from "@ngx-translate/core";
import { LanguageEnum } from "@shared/enums/language.enum";
import { distinctUntilChanged, skip } from "rxjs/operators";
import { ImprintModalComponent } from "../imprint-modal/imprint-modal.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "app-driveb-legal-info-modal",
    templateUrl: "./legal-info-modal.component.html",
    styleUrls: ["./legal-info-modal.component.scss"],
    standalone: false
})
export class LegalInfoModalComponent implements OnInit {
  termsUseText: string;
  imprintText: string;
  useTermsLink = "";

  constructor(
    private translateService: TranslateService,
    private languageService: LanguageService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    (this.termsUseText = this.translateService.instant("terms-of-use")),
      (this.imprintText = "Imprint");

    this.setUseTermsLink(this.translateService.currentLang as LanguageEnum);
    this.translateService.onLangChange
      .pipe(distinctUntilChanged())
      .subscribe((data) => {
        this.setUseTermsLink(data.lang as LanguageEnum);
        this.termsUseText = this.translateService.instant("terms-of-use");
      });
  }

  private setUseTermsLink(language: LanguageEnum): void {
    if (language === LanguageEnum.ES) {
      this.useTermsLink = "https://driveb.com.ar/politica-de-privacidad.html";
      return;
    }
    this.useTermsLink = "smartfleet/public/privacy-policy-and-use-terms";
  }

  openModalImprint(): void {
    this.dialog.open(ImprintModalComponent, { width: "600px" });
  }
}
